import { useViewResolverContext as useViewResolverContextLib } from "@ldp/view-resolver-lite";
/**
 * Hook to get the view resolver context.
 */
export const useViewResolverContext = useViewResolverContextLib;

export default useViewResolverContext;
